// extracted by mini-css-extract-plugin
export default {"review_result_cell_container":"styles_review_result_cell_container__VGx3X","review_result_cell_inner_row":"styles_review_result_cell_inner_row__6mhIU"};